module.exports = __webpack_public_path__ + "static/media/img1.555ab3a8.jpg";